// library imports
import { useDispatch } from "react-redux";

// User Component imports
import { ExecOpsRequest } from "apis/AdminOpsApiCommon";

// 運営ツール: 外見動画の削除
const AdminOpsAppearanceDeleteApi = () => {
    const dispatch = useDispatch();
    const url = "/admin/ops_appearance_delete";

    const ExecAdminOpsAppearanceDeleteApi = async (tAppearanceId) => {
        return ExecOpsRequest(dispatch, { url: url, requestParams: { t_appearance_id: tAppearanceId } });
    };

    return ExecAdminOpsAppearanceDeleteApi;
};

export default AdminOpsAppearanceDeleteApi;
